@if (selectedCompany && isReadOnly && showInternalNavigator) {
    <app-internal-navigator
        [path]="routeToSingle"
        [label]="selectedCompany.name"
        [isActive]="selectedCompany.isActive"
    ></app-internal-navigator>
} @else {
    <app-type-ahead-companies
        [isReadOnly]="isReadOnly"
        [displaySelected]="displaySelectedCompany"
        [selectedCompany]="selectedCompany"
        [editorInfoAllowAction]="editorInfoAllowAction"
        (selectedCompanyChange)="onSelectedCompany($event)"
        [isActive]="isActive"
        [path]="routeToSingle"
    >
    </app-type-ahead-companies>
}
